import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {  
  folderCleanUp,
  setCasualObj,
} from "../../../features/folder/folderSlice"; 
 
import InsideHeader from "../../../components/InsideHeader";  
import HowToAddCasualProfileModal from "./modal/HowToAddCasualProfileModal";
import { fetchCasual } from "../../../features/dropdown/dropdownSlice";
import CasualTable from "./CasualTable";
import NoCont from "../../personnel/NoCont";

export default function Casual() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);
  const { casualData} = useSelector((state) => state.dropdown);

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }

  async function handleAddFolder() {
    await dispatch(setCasualObj(""))
    await setopen(true);
  }

  const handleGoBack = () => {
    navigate("/outbox");
  };

  async function handleFetchData() {
    await dispatch(fetchCasual());
  }

  async function handleUploadFile() { 
    await navigate("/personnel/add/file-upload");
  }

  useEffect(() => {}, [casualData]);

  useEffect(() => {
    handleFetchData();
    dispatch(folderCleanUp());
  }, []);



  return (
    <>
      <div className="w-full overflow-y-scroll h-full">
    
        <InsideHeader
          title="Casual Profile"
          subtitle="Manage Casual Profile within your institution"
          back={false} 
        />

        <div className="mt-[1.25rem] lg:p-10 p-3 lg: h-full bg-white rounded-[10px]">
         
            <CasualTable 
              handleAddFolder={handleAddFolder}
            />
         
         
        </div>
     
        <HowToAddCasualProfileModal
          handleFetchData={handleFetchData}
          uploadGraduateFile={handleUploadFile}
          open={open}
          handleCancel={handleCancel}
        />
        
      </div>
    </>
  );
}
